import * as React from 'react';
import Slider from 'rc-slider';
import { SliderProps } from 'rc-slider/lib/Slider';

export interface IResponsiveRcSlider extends SliderProps {
}

export const ResponsiveRcSlider = React.forwardRef<any, IResponsiveRcSlider>((props, ref) => {
    let {
        onChange: originalOnChange,
        value: originalValue,
        ...restRangeProps
    } = props;

    const [ innerValue, setInnerValue ] = React.useState(originalValue);

    React.useEffect(() => {
        setInnerValue(originalValue);
    }, [ originalValue ]);

    const onChange = (value: SliderProps['value']) => {
        setInnerValue(value);
        originalOnChange(value);
    };

    return (
        <Slider
            {...restRangeProps}
            value={innerValue}
            onChange={onChange}
        />
    );
});
